import { apiClient } from "./apiClient";

export const userWorkspaceSettingsService = {
    getSettings: async (token, workspaceId) => {
        return apiClient(`/workspaces/${workspaceId}/user-settings`, {
            token,
            method: "GET"
        });
    },

    updateSettings: async (token, workspaceId, settings) => {
        return apiClient(`/workspaces/${workspaceId}/user-settings`, {
            token,
            method: "PUT",
            body: settings
        });
    },
};
